"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _filter = _interopRequireDefault(require("lodash/fp/filter"));
var _map = _interopRequireDefault(require("lodash/fp/map"));
var _gt = _interopRequireDefault(require("lodash/fp/gt"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _size = _interopRequireDefault(require("lodash/fp/size"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _escapeRegExp = _interopRequireDefault(require("lodash/fp/escapeRegExp"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isLabelMatch = function isLabelMatch(keyword) {
  return function (source) {
    return new RegExp((0, _escapeRegExp["default"])(keyword), 'i').test(source === null || source === void 0 ? void 0 : source.label);
  };
};
var filterItems = function filterItems(keyword) {
  return (0, _filter["default"])(isLabelMatch(keyword));
};
var filterGroups = function filterGroups(keyword) {
  return (0, _compose["default"])((0, _filter["default"])((0, _compose["default"])(function (itemSize) {
    return (0, _gt["default"])(itemSize, 0);
  }, _size["default"], (0, _prop["default"])('items'))), (0, _map["default"])(function (group) {
    return _objectSpread(_objectSpread({}, group), {}, {
      items: filterItems(keyword)(group.items)
    });
  }));
};
var useSearch = function useSearch(_ref) {
  var _ref$initalKeyword = _ref.initalKeyword,
    initalKeyword = _ref$initalKeyword === void 0 ? '' : _ref$initalKeyword,
    _ref$grouped = _ref.grouped,
    grouped = _ref$grouped === void 0 ? false : _ref$grouped,
    source = _ref.source;
  var _useState = (0, _react.useState)(initalKeyword),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    keyword = _useState2[0],
    setKeyword = _useState2[1];
  var filtered = (0, _react.useMemo)(function () {
    if (keyword) {
      return grouped ? filterGroups(keyword)(source) : filterItems(keyword)(source);
    }
    return source;
  }, [grouped, keyword, source]);
  return {
    keyword: keyword,
    setKeyword: setKeyword,
    items: filtered
  };
};
var _default = exports["default"] = useSearch;